import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MainService } from '../service/main.service';
import { EditorService } from '../service/editor.service';
import Swal from 'sweetalert2';
import { session } from '../../../environments/environment.session';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit {
  constructor(private editorService: EditorService,) { }
  // editor related code
  optionsButtons: any
  advancedOptionButton:  any


  // fontName
  // fontSizeRef
  writingArea: any
  linkButton!: HTMLButtonElement
  alignButtons!: NodeListOf<Element>
  spacingButtons!: NodeListOf<Element>
  formatButtons!: NodeListOf<Element>
  scriptButtons!: NodeListOf<Element>
  ebillUser: any;
  to_data: any = {};
  current_date!: string;
  department_data: any;


  @ViewChild('header', { static: true }) header!: ElementRef<HTMLButtonElement>;
  @ViewChild('body', { static: true }) body!: ElementRef<HTMLButtonElement>;
  @ViewChild('footer', { static: true }) footer!: ElementRef<HTMLButtonElement>;
  @ViewChild('contentInsideBody', { static: true }) contentInsideBody!: ElementRef<HTMLButtonElement>;
  @ViewChild('createLink', { static: true }) createLink!: ElementRef<HTMLButtonElement>;

  async ngOnInit() {
    // getting data from service start
    this.to_data = {}
    this.editorService.header = this.header
    this.editorService.footer = this.footer
    this.editorService.body = this.contentInsideBody
    this.editorService.language = "English"


    this.ebillUser = this.ebillUser = JSON.parse(atob(session.erpUser));
    //  this.department_data = this.editorService.department_data;
    this.current_date = this.editorService.current_date;
    this.to_data = this.editorService.to_data;
    if (Object.keys(this.to_data).length > 0) {
      await this.setHtmlData();
    }
    
    this.optionsButtons = document.querySelectorAll(".option-button");
    this.advancedOptionButton = document.querySelectorAll(".adv-option-button");
    this.linkButton = this.createLink.nativeElement


    this.alignButtons = document.querySelectorAll(".align");
    this.spacingButtons = document.querySelectorAll(".spacing");
    this.formatButtons = document.querySelectorAll(".format");
    this.scriptButtons = document.querySelectorAll(".script");

    this.optionsButtons.forEach((button:any) => {
      button.addEventListener("click", () => {
        this.modifyText(button.id, false, null);
      });
    });

    this.linkButton.addEventListener("click", () => {
      let userLink:any = prompt("Enter a URL");
      if (/http/i.test(userLink)) {
        this.modifyText(this.linkButton.id, false, userLink);
      } else {
        userLink = "http://" + userLink;
        this.modifyText(this.linkButton.id, false, userLink);
      }
    });
    this.initializer();
  }
  async setHtmlData() {
    let data: any = JSON.parse(this.to_data)
    this.contentInsideBody.nativeElement.innerHTML = data['body']
    this.class_hindi = data.is_hindi_font //this.editorService.language==="Hindi"?true:false
  }

  initializer = () => {
    this.highlighter(this.alignButtons, true);
    this.highlighter(this.spacingButtons, true);
    this.highlighter(this.formatButtons, false);
    this.highlighter(this.scriptButtons, true);

  };

  modifyText = (command: string, defaultUi: boolean | undefined, value: string | null | undefined | any) => {
    document.execCommand(command, defaultUi, value);
  };


  highlighter:any = (className: any[], needsRemoval: boolean) => {
    className.forEach((button: { addEventListener: (arg0: string, arg1: () => void) => void; classList: { contains: (arg0: string) => any; add: (arg0: string) => void; toggle: (arg0: string) => void; }; }) => {
      button.addEventListener("click", () => {
        if (needsRemoval) {
          let alreadyActive = false;
          if (button.classList.contains("active")) {
            alreadyActive = true;
          }
          this.highlighterRemover(className);
          if (!alreadyActive) {
            button.classList.add("active");
          }
        } else {
          button.classList.toggle("active");
        }
      });
    });
  };


  highlighterRemover = (className: any[]) => {
    className.forEach((button: { classList: { remove: (arg0: string) => void; }; }) => {
      button.classList.remove("active");
    });
  };


  date_converter: Object = { krutidev: "fnukad &", english: "Date -" }

  class_hindi = false
  hindiTyping() {
    Swal.fire({
      title: 'Are you sure? You want to change the language',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Change it!'
    }).then(async (result) => {
      if (result.value) {
        this.to_data = {}
        this.class_hindi = true
        this.editorService.language = 'Hindi'

      }
    })
  }
  englishTyping() {
    Swal.fire({
      title: 'Are you sure? You want to change the language',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Change it!'
    }).then(async (result) => {
      if (result.value) {
        this.to_data = null
        this.class_hindi = false
        this.editorService.language = 'English'
      }
    })
  }


  handlePaste(event: ClipboardEvent): void {
    event.preventDefault(); 
    const clipboardData = event.clipboardData;
    if (!clipboardData) return; 
    const pastedHTML = clipboardData.getData('text/html') || clipboardData.getData('text/plain');
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = pastedHTML;
    this.removeAllStyles(tempDiv);
    this.insertSanitizedContentAtCursor(tempDiv.innerHTML);
  }

  removeAllStyles(element: HTMLElement): void {
    element.querySelectorAll('style, link').forEach(el => el.remove());
    element.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
  }


  insertSanitizedContentAtCursor(sanitizedHTML: string): void {
    const sel = window.getSelection();
    if (sel && sel.rangeCount && this.contentInsideBody && this.contentInsideBody.nativeElement) {
      const range = sel.getRangeAt(0);
      range.deleteContents();
      const frag = document.createRange().createContextualFragment(sanitizedHTML);
      range.insertNode(frag);
      const newRange = document.createRange();
      newRange.collapse(true);
      sel.removeAllRanges();
      sel.addRange(newRange);
    }
  }

  getAllcontent = () => {
    const header = this.header.nativeElement.innerHTML
    const body = this.body.nativeElement.innerHTML
    const footer = this.footer.nativeElement.innerHTML
    let obj = { 'header': header, 'body': body, 'footer': footer, is_hindi_font: this.class_hindi,bodytext: this.body.nativeElement.innerText}
    this.editorService.to_data = JSON.stringify(obj)
  }
}
